import Utils from "../../../../shared/utils";

export const LOANS_SPREAD = Utils.buildMortPersonalAreaImgLink("loans-spread.svg");